import { render, staticRenderFns } from "./LawsuitPage.vue?vue&type=template&id=fb5cbbc2&scoped=true"
import script from "./LawsuitPage.vue?vue&type=script&lang=js"
export * from "./LawsuitPage.vue?vue&type=script&lang=js"
import style0 from "./LawsuitPage.vue?vue&type=style&index=0&id=fb5cbbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5cbbc2",
  null
  
)

export default component.exports